import Styles from './AnalyticsPage.module.css'
import Colors from 'Theme/Colors'
import {
  OverviewCard,
  PeakHourCard,
  TokensActivityCard,
  TokensStatisticsCard,
  TopCitiesCard,
  TopSitesCard,
  TransactionsStatsCard,
  AverageDurationCard,
  ConnectorsStatusCard,
  RevenueTrendCard,
  GraphCard,
  IFsvg,
} from 'Components'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import AuthSelectors from 'Stores/Auth/Selectors'
import InfinityEnums from 'Enums/InfinityEnums'
import LoadingBar from 'react-top-loading-bar'
import GridLayout, { Responsive, WidthProvider } from 'react-grid-layout'
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

const ResponsiveGridLayout = WidthProvider(Responsive)
const layouts = {
  lg: [
    { i: 'OverView', x: 0, y: 0, w: 2.5, h: 2, static: true },
    { i: 'PeakHour', x: 0, y: 4.25, w: 1.25, h: 2, static: true },
    { i: 'ConnectorsStatus', x: 0, y: 2, w: 1.25, h: 1, static: true },
    { i: 'AverageDuration', x: 1.25, y: 2, w: 1.25, h: 1, static: true },
    { i: 'TopSites', x: 2.5, y: 0, w: 1.5, h: 3, static: true },
    { i: 'TransactionsStats', x: 0, y: 3, w: 2, h: 1.25, static: true },
    { i: 'TopCities', x: 1.25, y: 4.25, w: 1.5, h: 2, static: true },
    { i: 'TokensActivity', x: 2.75, y: 4.25, w: 1.25, h: 2, static: true },
    { i: 'RevenueTrend', x: 2, y: 3, w: 2, h: 1.25, static: true },
    { i: 'TokensStatistics', x: 0, y: 6.25, w: 2, h: 1, static: true },
  ],
  md: [
    { i: 'OverView', x: 0, y: 0, w: 2, h: 2, static: true },
    { i: 'ConnectorsStatus', x: 0, y: 2, w: 1, h: 1, static: true },
    { i: 'AverageDuration', x: 2, y: 2, w: 1, h: 1, static: true },
    { i: 'TopSites', x: 0, y: 3, w: 2, h: 3, static: true },
    { i: 'TransactionsStats', x: 0, y: 6, w: 2, h: 1.25, static: true },
    { i: 'TokensStatistics', x: 0, y: 7.25, w: 2, h: 1, static: true },
    { i: 'PeakHour', x: 0, y: 8.25, w: 1, h: 2, static: true },
    { i: 'TopCities', x: 1, y: 8.25, w: 1, h: 2, static: true },
    { i: 'TokensActivity', x: 0, y: 10.25, w: 1, h: 2, static: true },
    { i: 'RevenueTrend', x: 1, y: 10.25, w: 1, h: 2, static: true },
  ],
  sm: [
    { i: 'OverView', x: 0, y: 0, w: 1, h: 2, static: true },
    { i: 'ConnectorsStatus', x: 0, y: 2, w: 1, h: 1, static: true },
    { i: 'AverageDuration', x: 0, y: 3, w: 1, h: 1, static: true },
    { i: 'TopSites', x: 0, y: 4, w: 1, h: 3, static: true },
    { i: 'TransactionsStats', x: 0, y: 7, w: 1, h: 1.25, static: true },
    { i: 'TokensStatistics', x: 0, y: 8.25, w: 1, h: 1, static: true },
    { i: 'PeakHour', x: 0, y: 9.25, w: 1, h: 2, static: true },
    { i: 'TopCities', x: 0, y: 11.25, w: 1, h: 2, static: true },
    { i: 'TokensActivity', x: 0, y: 13.25, w: 1, h: 2, static: true },
    { i: 'RevenueTrend', x: 0, y: 15.25, w: 1, h: 1, static: true },
  ],
  xs: [
    { i: 'OverView', x: 0, y: 0, w: 1, h: 2, static: true },
    { i: 'ConnectorsStatus', x: 0, y: 2, w: 1, h: 1, static: true },
    { i: 'AverageDuration', x: 0, y: 3, w: 1, h: 1, static: true },
    { i: 'TopSites', x: 0, y: 4, w: 1, h: 3, static: true },
    { i: 'TransactionsStats', x: 0, y: 7, w: 1, h: 1.25, static: true },
    { i: 'TokensStatistics', x: 0, y: 8.25, w: 1, h: 1, static: true },
    { i: 'PeakHour', x: 0, y: 9.25, w: 1, h: 2, static: true },
    { i: 'TopCities', x: 0, y: 11.25, w: 1, h: 2, static: true },
    { i: 'TokensActivity', x: 0, y: 13.25, w: 1, h: 2, static: true },
    { i: 'RevenueTrend', x: 0, y: 15.25, w: 1, h: 1, static: true },
  ],
  xxs: [
    { i: 'OverView', x: 0, y: 0, w: 1, h: 2, static: true },
    { i: 'ConnectorsStatus', x: 0, y: 2, w: 1, h: 1, static: true },
    { i: 'AverageDuration', x: 0, y: 3, w: 1, h: 1, static: true },
    { i: 'TopSites', x: 0, y: 4, w: 1, h: 3, static: true },
    { i: 'TransactionsStats', x: 0, y: 7, w: 1, h: 1.75, static: true },
    { i: 'TokensStatistics', x: 0, y: 8.75, w: 1, h: 1, static: true },
    { i: 'PeakHour', x: 0, y: 9.75, w: 1, h: 2, static: true },
    { i: 'TopCities', x: 0, y: 11.75, w: 1, h: 2, static: true },
    { i: 'TokensActivity', x: 0, y: 13.75, w: 1, h: 2, static: true },
    { i: 'RevenueTrend', x: 0, y: 15.75, w: 1, h: 1, static: true },
  ],
}

const AnalyticsPage = ({ operatorUser }) => {
  const [progress, setProgress] = useState(0)
  const canView = operatorUser.permissions.includes(
    InfinityEnums.OperatorUserPermission.CAN_VIEW_ANALYTICS_DATA,
  )
  const today = new Date()
  const dayOfMonth = today.getDate()

  const selectInitialValue =
    dayOfMonth <= 7
      ? { label: 'Last Month', value: 'lastMonth' }
      : { label: 'This Month', value: 'thisMonth' }
  const { t } = useTranslation()
  return (
    <div className={Styles.Wrapper}>
      <LoadingBar
        color={Colors.primary}
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      {canView && (
        <ResponsiveGridLayout
          layouts={layouts}
          breakpoints={{ lg: 1470, md: 1152, sm: 768, xs: 480, xxs: 0 }}
          cols={{ lg: 4, md: 2, sm: 1, xs: 1, xxs: 1 }}
          rowHeight={280}
          autoSize
          margin={[8, 8]}
          containerPadding={[0, 0]}
          isResizable={false}
          isDraggable={false}
        >
          <div key="OverView">
            <GraphCard
              title={t('Analytics.Overview')}
              icon={<IFsvg.Bolt />}
              isSelectPicker={true}
              graph={OverviewCard}
              selectData={[
                { label: 'This Month', value: 'thisMonth' },
                { label: 'Last Month', value: 'lastMonth' },
                { label: 'Last 3 Months', value: 'last3Months' },
                { label: 'Last 6 Months', value: 'last6Months' },
                { label: 'This Year', value: 'thisYear' },
                { label: 'Last Year', value: 'lastYear' },
              ]}
              selectInitialValue={selectInitialValue}
              selectIcon={
                <IFsvg.CalendarMonth
                  style={{ marginTop: 4 }}
                  height={16}
                  width={16}
                />
              }
            />
          </div>
          <div key="PeakHour">
            <GraphCard
              title={t('Analytics.PeakHour')}
              icon={<IFsvg.ModeHeat />}
              isSelectPicker={true}
              graph={PeakHourCard}
              selectData={[
                { label: 'This Month', value: 'thisMonth' },
                { label: 'Last Month', value: 'lastMonth' },
                { label: 'Last 3 Months', value: 'last3Months' },
                { label: 'Last 6 Months', value: 'last6Months' },
                { label: 'This Year', value: 'thisYear' },
                { label: 'Last Year', value: 'lastYear' },
              ]}
              selectInitialValue={selectInitialValue}
              selectIcon={
                <IFsvg.CalendarMonth
                  style={{ marginTop: 4 }}
                  height={16}
                  width={16}
                />
              }
            />
          </div>
          <div key="ConnectorsStatus">
            <GraphCard
              title={t('Analytics.ChargingStations')}
              width={'100%'}
              height={'100%'}
              icon={<IFsvg.EvStation />}
              graph={ConnectorsStatusCard}
              refresh={true}
            />
          </div>
          <div key="AverageDuration">
            <GraphCard
              title={t('Analytics.AverageDuration')}
              icon={<IFsvg.AverageTime />}
              isSelectPicker={true}
              graph={AverageDurationCard}
              selectData={[
                { label: 'This Month', value: 'thisMonth' },
                { label: 'Last Month', value: 'lastMonth' },
                { label: 'Last 3 Months', value: 'last3Months' },
                { label: 'Last 6 Months', value: 'last6Months' },
                { label: 'This Year', value: 'thisYear' },
                { label: 'Last Year', value: 'lastYear' },
              ]}
              selectInitialValue={selectInitialValue}
              selectIcon={
                <IFsvg.CalendarMonth
                  style={{ marginTop: 4 }}
                  height={16}
                  width={16}
                />
              }
            />
          </div>
          <div key="TopSites">
            <GraphCard
              title={t('Analytics.TopSites')}
              icon={<IFsvg.MapPinPreview />}
              isSelectPicker={true}
              graph={TopSitesCard}
              selectData={[
                { label: 'This Month', value: 'thisMonth' },
                { label: 'Last Month', value: 'lastMonth' },
                { label: 'Last 3 Months', value: 'last3Months' },
                { label: 'Last 6 Months', value: 'last6Months' },
                { label: 'This Year', value: 'thisYear' },
                { label: 'Last Year', value: 'lastYear' },
              ]}
              selectInitialValue={selectInitialValue}
              selectIcon={
                <IFsvg.CalendarMonth
                  style={{ marginTop: 4 }}
                  height={16}
                  width={16}
                />
              }
            />
          </div>
          <div key="TransactionsStats">
            <GraphCard
              title={t('Analytics.TransactionsStats')}
              icon={<IFsvg.QueryStats />}
              graph={TransactionsStatsCard}
              selectIcon={
                <IFsvg.CalendarMonth
                  style={{ marginTop: 4 }}
                  height={16}
                  width={16}
                />
              }
              selectTitle={t('Analytics.ThisMonth')}
            />
          </div>
          <div key="TopCities">
            <GraphCard
              title={t('Analytics.TopCities')}
              icon={<IFsvg.Map />}
              isSelectPicker={true}
              graph={TopCitiesCard}
              selectData={[
                { label: 'This Month', value: 'thisMonth' },
                { label: 'Last Month', value: 'lastMonth' },
                { label: 'Last 3 Months', value: 'last3Months' },
                { label: 'Last 6 Months', value: 'last6Months' },
                { label: 'This Year', value: 'thisYear' },
                { label: 'Last Year', value: 'lastYear' },
              ]}
              selectInitialValue={selectInitialValue}
              selectIcon={
                <IFsvg.CalendarMonth
                  style={{ marginTop: 4 }}
                  height={16}
                  width={16}
                />
              }
            />
          </div>
          <div key="TokensActivity">
            <GraphCard
              title={t('Analytics.TokenActivity')}
              icon={<IFsvg.IdCard />}
              graph={TokensActivityCard}
              selectIcon={
                <IFsvg.CalendarMonth
                  style={{ marginTop: 4 }}
                  height={16}
                  width={16}
                />
              }
              selectTitle={t('Analytics.AllTime')}
            />
          </div>
          <div key="TokensStatistics">
            <GraphCard
              title={t('Analytics.TokensStats')}
              icon={<IFsvg.Statistics />}
              isSelectPicker={true}
              graph={TokensStatisticsCard}
              selectData={[
                { label: 'This Month', value: 'thisMonth' },
                { label: 'Last Month', value: 'lastMonth' },
                { label: 'Last 3 Months', value: 'last3Months' },
                { label: 'Last 6 Months', value: 'last6Months' },
                { label: 'This Year', value: 'thisYear' },
                { label: 'Last Year', value: 'lastYear' },
              ]}
              selectInitialValue={selectInitialValue}
              selectIcon={
                <IFsvg.CalendarMonth
                  style={{ marginTop: 4 }}
                  height={16}
                  width={16}
                />
              }
            />
          </div>
          <div key="RevenueTrend">
            <GraphCard
              title={t('Analytics.RevenueTrend')}
              icon={<IFsvg.Trend />}
              isSelectPicker={true}
              graph={RevenueTrendCard}
              selectData={[
                { label: 'This Month', value: 'thisMonth' },
                { label: 'Last Month', value: 'lastMonth' },
                { label: 'Last 3 Months', value: 'last3Months' },
                { label: 'Last 6 Months', value: 'last6Months' },
                { label: 'This Year', value: 'thisYear' },
                { label: 'Last Year', value: 'lastYear' },
              ]}
              selectInitialValue={selectInitialValue}
              selectIcon={
                <IFsvg.CalendarMonth
                  style={{ marginTop: 4 }}
                  height={16}
                  width={16}
                />
              }
            />
          </div>
        </ResponsiveGridLayout>
      )}
    </div>
  )
}

const mapStateToProps = (state) => ({
  operatorUser: AuthSelectors.getOperatorUser(state),
})

AnalyticsPage.propTypes = {
  operatorUser: PropTypes.object,
}

export default connect(mapStateToProps)(AnalyticsPage)
